function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-view"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 20
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "view",
  clipPath: "url(#clip-view)"
}, /*#__PURE__*/React.createElement("g", {
  id: "eye-outline",
  transform: "translate(-1 -1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M20.048,10.542c-.587-1.018-3.813-6.123-9.3-5.958-5.069.128-8,4.583-8.8,5.958a.917.917,0,0,0,0,.917c.577,1,3.667,5.958,9.066,5.958h.229c5.069-.128,8.012-4.583,8.8-5.958A.917.917,0,0,0,20.048,10.542ZM11.2,15.583C7.251,15.675,4.675,12.292,3.868,11c.917-1.476,3.309-4.492,6.976-4.583,3.932-.1,6.517,3.291,7.333,4.583C17.233,12.476,14.868,15.492,11.2,15.583Z",
  fill: "#2e5bff"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape-2",
  "data-name": "Shape",
  d: "M11,7.792A3.208,3.208,0,1,0,14.208,11,3.208,3.208,0,0,0,11,7.792Zm0,4.583A1.375,1.375,0,1,1,12.375,11,1.375,1.375,0,0,1,11,12.375Z",
  fill: "#2e5bff"
})));

var SvgView = function SvgView(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgView, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/view.4af8305d.svg";
export { ForwardRef as ReactComponent };